import { Share2, Link as LinkIcon, MessageCircle, Facebook } from "lucide-react";
import { toast } from "sonner";

export function ShareButtons({ title }) {
  const url = window.location.href;
  const text = `${title} — Top End Wheels, Darwin car hire`;
  const wa = `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const copy = async () => {
    if (navigator.share) { try { await navigator.share({ title: text, url }); return; } catch { /* cancelled */ } }
    await navigator.clipboard.writeText(url);
    toast.success("Link copied");
  };
  const cls = "inline-flex items-center gap-1.5 text-xs border border-black/15 px-3 py-1.5 hover:border-[#BA5A3A] hover:text-[#BA5A3A] transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-2 mt-6" data-testid="share-buttons">
      <span className="overline text-[#595959] mr-1 flex items-center gap-1"><Share2 className="w-3.5 h-3.5"/> Share</span>
      <a href={wa} target="_blank" rel="noreferrer" className={cls} data-testid="share-whatsapp"><MessageCircle className="w-3.5 h-3.5"/> WhatsApp</a>
      <a href={fb} target="_blank" rel="noreferrer" className={cls} data-testid="share-facebook"><Facebook className="w-3.5 h-3.5"/> Facebook</a>
      <button onClick={copy} className={cls} data-testid="share-copy"><LinkIcon className="w-3.5 h-3.5"/> Copy link</button>
    </div>
  );
}
